export default class Throttle {
  static execute(timestamp, wait, fn) {
    if ((timestamp + wait - Date.now()) < 0) {
      fn()
      return Date.now();
    }
    return timestamp;
  }

  static set(func, timeFrame) {
    var lastTime = 0;
    return function(...args) {
        var now = Date.now();
        if (now - lastTime >= timeFrame) {
          func(...args);
          lastTime = now;
        }
    };
  }
}
